import { TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import InputAdornment from '@mui/material/InputAdornment';
import TodayIcon from '@mui/icons-material/Today';
import PropTypes from 'prop-types';

const propTypes = {
  selectDate: PropTypes.oneOfType([PropTypes.object]).isRequired,
  onChange: PropTypes.func.isRequired,
};
const useStyles = makeStyles({
  input: {},
});

const CustomDatePicker = ({ selectDate, onChange }) => {
  const [startDate, setStartDate] = React.useState(Date.parse(selectDate));
  const classes = useStyles();

  const onDateChange = (date) => {
    setStartDate(date);
    onChange(date);
  };
  return (
    <DatePicker
      className="date-picker-input"
      selected={startDate}
      closeOnScroll
      onChange={onDateChange}
      dateFormat="EEEE MMMM d, yyyy"
      placeholderText="Select Date :"
      customInput={
        <TextField
          className={classes.input}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <TodayIcon className="ic-today" />
              </InputAdornment>
            ),
          }}
        />
      }
    />
  );
};

CustomDatePicker.propTypes = propTypes;
export default CustomDatePicker;
